/**
 * Error utility functions
 */

/**
 * Checks if an error is a 429 rate limit error
 * @param {*} error - Error object or string
 * @returns {boolean} True if error is a 429 rate limit error
 */
export function isRateLimitError(error) {
  if (!error) return false
  
  // Check if error object has response.status === 429
  if (error.response?.status === 429 || error.status === 429) {
    return true
  }
  
  // Check error message/string
  const errorStr = typeof error === 'string' 
    ? error 
    : (error.message || error.error?.message || JSON.stringify(error))
  
  return errorStr.includes('429') || 
         errorStr.includes('Too many requests') || 
         errorStr.toLowerCase().includes('rate limit') ||
         errorStr.toLowerCase().includes('non-2xx status code')
}
